import { Edit, MapPin, MoreVertical, Search, Trash2 } from 'lucide-react'

import { useState } from 'react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Input } from '@/components/ui/input'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

import { ShippingZone } from '@/types/shipping'

export const ShippingZones = () => {
  const [searchTerm, setSearchTerm] = useState('')

  // Mock data
  const zones: ShippingZone[] = [
    {
      id: '1',
      name: 'United States',
      countries: ['US'],
      states: ['CA', 'NY', 'TX', 'FL'],
      enabled: true,
      createdAt: new Date(),
    },
    {
      id: '2',
      name: 'Europe',
      countries: ['GB', 'FR', 'DE', 'IT', 'ES'],
      enabled: true,
      createdAt: new Date(),
    },
    {
      id: '3',
      name: 'Canada',
      countries: ['CA'],
      enabled: true,
      createdAt: new Date(),
    },
  ]

  const filteredZones = zones.filter((zone) =>
    zone.name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <div>
      <div className="border-t border-border-subtle p-2">
        <div className="relative w-full sm:w-64">
          <Search className="absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Search zones"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-8"
          />
        </div>
      </div>

      <div className="border-t border-border-subtle">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Zone</TableHead>
              <TableHead>Countries</TableHead>
              <TableHead>States and regions</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Created</TableHead>
              <TableHead className="w-12"><span className="sr-only">Actions</span></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredZones.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} className="py-8 text-center text-text-2">
                  <MapPin className="mx-auto mb-2 size-8 text-muted-foreground" />
                  <p className="text-sm">No shipping zones found</p>
                </TableCell>
              </TableRow>
            ) : (
              filteredZones.map((zone) => (
                <TableRow key={zone.id}>
                  <TableCell className="font-medium text-ink">{zone.name}</TableCell>
                  <TableCell>
                    <div className="flex gap-1 flex-wrap">
                      {zone.countries.slice(0, 3).map((country) => (
                        <Badge key={country} tone="soft">
                          {country}
                        </Badge>
                      ))}
                      {zone.countries.length > 3 && (
                        <Badge tone="soft">
                          +{zone.countries.length - 3}
                        </Badge>
                      )}
                    </div>
                  </TableCell>
                  <TableCell>
                    {zone.states ? (
                      <span className="text-sm text-text-2">
                        {zone.states.length} states
                      </span>
                    ) : (
                      <span className="text-sm text-text-2">All</span>
                    )}
                  </TableCell>
                  <TableCell>
                    <Badge tone={zone.enabled ? 'success' : 'soft'}>
                      {zone.enabled ? 'Active' : 'Inactive'}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-sm text-text-2 tabular-nums">
                    {new Date(zone.createdAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="icon" aria-label="Actions">
                          <MoreVertical className="size-4" />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end">
                        <DropdownMenuItem>
                          <Edit className="size-4" />
                          Edit
                        </DropdownMenuItem>
                        <DropdownMenuItem className="text-destructive">
                          <Trash2 className="size-4" />
                          Delete
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
